import { storage } from '@/plugins/storage'
import { login, register, getUserInfo,codeLogin } from '@/api/login'

const state = {
  token: storage.get('TOKEN'),
  userInfo: storage.get('USER_INFO') || {},
  shopList: storage.get('SHOP_LIST') || [], //加入购物车
}

const getters = {
  getToken(state) {
    return state.token || storage.get('TOKEN')
  },
  getUserInfos(state) {
    return state.userInfo || storage.get('USER_INFO')
  },
  getShopList(state) {
    return state.shopList || storage.get('SHOP_LIST')
  },
}

const actions = {
  async getLogin({ commit }, data) {
    let { type,...params } = data
    console.log(type)
    let submit = type == 1 ? login : codeLogin
    const res = await submit({
      ...params,
    })
    if (res.code == 200) {
      commit('setToken', res.token)
      // commit('setUserInfo',res.data)
    }
  },

  async getRegister({ commit }, data) {
    const res = await register({
      ...data,
    })
    if (res.code == 200 || res.code == 1) {
      console.log(res.data)
      return res
    } else {
      return res
    }
  },

  logout({ commit }) {
    commit('setToken', '')
    commit('setUserInfo', {})
    commit('setShopList', [])
    window.location.href = '/login'
  },

  async getUserDetails({ commit }) {
    const res = await getUserInfo()
    if (res.code == 200) {
      commit('setUserInfo', res.user)
    }
  },

  //加入购物车
  addShopList({ commit }, data) {
    commit('setShopList', data)
  },
}

const mutations = {
  setToken(state, data) {
    storage.set('TOKEN', data)
    localStorage.setItem('TOKEN', data)
    state.token = storage.get('TOKEN')
  },
  setUserInfo(state, data) {
    storage.set('USER_INFO', data)
    localStorage.setItem('USER_INFO', data)
    state.userInfo = storage.get('USER_INFO')
  },
  setShopList(state, data) {
    storage.set('SHOP_LIST', data)
    localStorage.setItem('SHOP_LIST', data)
    state.shopList = storage.get('SHOP_LIST')
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
